export const styleSheet = theme => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            borderRight: `1px solid ${theme.colors.gray09}`,
            maxWidth: '320px',
            width: '100%',
            flex: '1',
            height: '100%',
            [`@media(max-width: ${theme.breakpoints.internal.mobile})`]: {
                height: 'unset',
                padding: `0 0 ${theme.margins.margin01} 0`,
                maxWidth: 'unset',
                overflowY: 'unset',
                borderLeft: 'unset'
            }
        },
        gptBlock: {
            display: 'flex',
            flexDirection: 'column',
            margin: '20px 20px 0',
            backgroundColor: theme.colors.gray01,
            borderRadius: 6,
            padding: '10px 12px',
            lineHeight: '1em'
        },
        gptLink: {
            marginTop: -8,
            color: theme.colors.blue08,
            textAlign: 'right',
            fontSize: 12,
            fontWeight: theme.fonts.fontWeights.medium,
            ':hover': {
                textDecoration: 'underline',
                color: theme.colors.blue11
            }
        },
        gptTitle: { marginBottom: 2 },
        header: {
            flexShrink: 0,
            padding: `${theme.margins.margin01} ${theme.margins.margin01} 0`,
            borderBottom: `1px solid ${theme.colors.gray01}`,
            height: 90,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            '.contentTab-selected': {
                color: theme.colors.black01
            }
        },
        scrollContainer: {
            flex: 1,
            padding: `0 0 ${theme.margins.margin01}`,
            overflowY: 'auto',
            '::-webkit-scrollbar': {
                width: '0px',
                background: 'transparent'
            }
        },
        searchBox: {
            input: {
                height: 30,
                fontSize: theme.fonts.fontSizes.size01,
                backgroundColor: theme.colors.gray01,
                borderRadius: 15,
                paddingLeft: 30
            },
            '.iconWrapper': {
                height: 30,
                left: 8
            },
            '.clearInput': {
                height: 30,
                right: 8
            }
        },
        selectedTermWrapper: {
            backgroundColor: theme.colors.white02,
            position: 'sticky',
            top: 0,
            padding: '20px 20px 0',
            zIndex: 1
        },
        selectedTerm: {
            backgroundColor: theme.colors.gray03,
            display: 'flex',
            justifyContent: 'space-between',
            padding: 10,
            borderRadius: 6,
            cursor: 'pointer',
            '.selectedTermParent': {
                color: theme.colors.gray06,
                marginTop: 4
            },
            ':hover': {
                '.selectedTermBack': {
                    backgroundColor: theme.colors.blue08
                },
                '.selectedTermParent': {
                    color: theme.colors.blue08
                },
                'svg g': {
                    fill: theme.colors.white01
                }
            },
            ':active': {
                '.selectedTermBack': {
                    backgroundColor: theme.colors.blue11
                },
                '.selectedTermParent': {
                    color: theme.colors.blue11
                }
            }
        },
        selectedTermBack: {
            display: 'flex',
            alignItems: 'center',
            color: theme.colors.black01,
            backgroundColor: theme.colors.white02,
            borderRadius: 6,
            width: 28,
            justifyContent: 'center'
        },
        selectedTermName: {
            lineHeight: '12px'
        },
        tabs: {
            flex: 'unset',
            marginBottom: -1,
            '.contentTab': {
                ':hover': {
                    color: theme.colors.gray06
                },
                ':active': {
                    color: theme.colors.black01
                }
            }
        },
        loader: {
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        empty: {
            padding: theme.margins.margin01
        },
        emptyText: {
            color: theme.colors.gray04,
            lineHeight: '1.3em',
            paddingTop: 10,
            textAlign: 'center'
        }
    };
};
